import create from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from 'axios';
import produce from 'immer';
import Cookies from 'js-cookie'


const usePositionsStore = create((set, get) => ({
    positions: {},
    positionsCount: 0,
    fetchPositions: async () => {
        console.log('FetchPositrion')
      const token = Cookies.get('token')
      try {    
      const res = await axios({
        headers: { Authorization: token },
        method: "GET",
        url:"/api/get_all_positions",
        timeout : 2000
      })
      set({positions : await res.data})
      } catch (err) {
        console.log(err)
      }
    //   get().countPositions()
    },
    updatePosition: (positions_infos) => {
        get().fetchPositions()
    
    },
    removePosition: (positions) => {

        get().fetchPositions()
        // get().countPositions()
      },
    addPosition: (positions) => {

    get().fetchPositions()
    // get().countPositions()
    },
 
    // countPositions: () => {
    //   const positions = get().algos
    //   let count = 0
    //   for (const exchange in algos) {
    //     for (const instrument in algos[exchange]){
    //       for (const side in algos[exchange][instrument]) {
    //         for (const algo in algos[exchange][instrument][side]){
    //           count ++            
    //         }
    //       }
    //     }
    //   }
    //   set({positionsCount : count})
    // }
  }))
  
  
  
  export default usePositionsStore